import { render, staticRenderFns } from "./bottomSetting.vue?vue&type=template&id=7c08ff09"
import script from "./bottomSetting.vue?vue&type=script&lang=js"
export * from "./bottomSetting.vue?vue&type=script&lang=js"
import style0 from "./bottomSetting.vue?vue&type=style&index=0&id=7c08ff09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports